import { render, staticRenderFns } from "./CourseFilesList.vue?vue&type=template&id=77ec0a62&scoped=true"
import script from "./CourseFilesList.vue?vue&type=script&lang=js"
export * from "./CourseFilesList.vue?vue&type=script&lang=js"
import style0 from "./CourseFilesList.vue?vue&type=style&index=0&id=77ec0a62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ec0a62",
  null
  
)

export default component.exports